// extracted by mini-css-extract-plugin
export default {"container":"WhiteSpace_container__Btgy8"};